

























import Str from '@/utils/Str';
import Vue from 'vue';

export default Vue.extend({
    props: {
        icon: {
            type: String,
            required: true,
        },
        action: {
            type: String,
            required: true,
        },
        url: {
            type: String,
            default: null,
        },
    },
    computed: {
        isLink(): boolean {
            return !!this.url;
        },
        actionText(): string {
            return this.$ui.desktop ? this.action : Str.capitalize(this.action);
        },
    },
});
